<template>
  <div class="login-view__wrapper bg-white-2">
    <form
      class="login-view__content bg-white-1 ring-strokes h-full pt-8 pl-8 ring-1"
      @submit.prevent="e => $emit('submit', e)"
    >
      <div class="login-view__logo">
        <img class="mb-2 h-8" src="../assets/images/engage.svg" />
      </div>
      <div class="login-view__inputs pt-8">
        <div class="flex flex-col items-stretch gap-8 *:last:mb-8">
          <p v-if="title" class="text-black-1 text-xl">{{ title }}</p>
          <Transition mode="out-in">
            <RfAlert v-if="error || success" :type="error ? 'error' : 'success'">
              {{ error || success }}
            </RfAlert>
          </Transition>
        </div>
        <div>
          <slot name="description"></slot>
          <slot name="inputs"></slot>
        </div>
        <div class="pt-8">
          <slot name="footer"></slot>
        </div>
      </div>
    </form>
  </div>
</template>

<script setup>
import RfAlert from "@/components/alerts/RfAlert.vue";

defineEmits(["submit"]);
defineProps({
  title: { type: String, default: "" },
  error: { type: String, default: "" },
  success: { type: String, default: "" },
});
</script>

<style lang="scss" scoped>
.login-view {
  &__wrapper {
    height: 100vh;
    height: 100dvh;
  }

  &__content {
    margin-left: 35%;
  }

  &__logo {
    padding-top: 14%;
  }

  &__inputs {
    max-width: 480px;
  }
}
</style>
